'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import withScreen from 'AdsUI/lib/withScreen';
import UIPanelNavigator from 'UIComponents/panel/UIPanelNavigator';
import AudienceCreationTypeSelectPanel from 'AdsUI/components/audiences/AudienceCreationTypeSelectPanel';
import { isFBAccountConnected, isPortalUntrustworthy, isLinkedInAccountConnected } from 'AdsUI/selectors/AccountsSelectors';
import { fetchAudiences, fetchPixels, installAndCreatePixels } from 'AdsUI/actions/AudiencesActions';
import { hasAccessToContactListAudiences, hasLICompanyListAudience, getListBasedAudienceLimit } from 'AdsUI/selectors/AuthSelectors';
import { postTimedNotification } from 'AdsUI/actions/NotificationActions';
import { AudienceTypes, AudienceCreationPanels } from 'AdsUI/lib/Constants';
import { getMultiFetchedSuccessfully, getRequestStatus } from 'AdsUI/selectors/RequestStatusSelectors';
import { isContactListAudienceCreationDisabled, metListBasedAudienceCreationLimit } from 'AdsUI/selectors/AudienceCreationSelectors';
import makeLoadable from 'AdsUI/lib/makeLoadable';
const AudienceCreationPanelLoader = makeLoadable(() => import('AdsUI/components/audiences/AudienceCreationPanel'));
const isAllAudienceDataFetched = getMultiFetchedSuccessfully('audiences', 'pixels', 'audiencesUsageInfo'); // Map used for amplitude tracking purposes

const AudiencePanelToTypeMap = {
  [AudienceTypes.CONTACT_LIST]: 'contact list',
  [AudienceTypes.WEBSITE]: 'pixel',
  [AudienceTypes.LOOKALIKE]: 'lookalike',
  [AudienceTypes.COMPANY_LIST]: 'company list'
};
const PANEL_WIDTH = 550;

class AudiencePanelNavigator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPanel: AudienceCreationPanels.AUDIENCE_TYPE_SELECTION
    };
    this.onAudienceTypeSelected = this.onAudienceTypeSelected.bind(this);
    this.onPreviousButtonClick = this.onPreviousButtonClick.bind(this);
  }

  componentDidMount() {
    if (!this.props.fetched) {
      this.props.fetchAudiences();
      this.props.fetchPixels();
    }

    usageTracker.track('modifyAudience', {
      action: 'Opened create audience'
    });
  }

  onAudienceTypeSelected(audienceType) {
    this.setState({
      currentPanel: audienceType
    });
    usageTracker.track('modifyAudience', {
      action: 'Chose audience type',
      type: AudiencePanelToTypeMap[audienceType]
    });
  }

  onPreviousButtonClick() {
    this.setState({
      currentPanel: AudienceCreationPanels.AUDIENCE_TYPE_SELECTION
    });
  }

  getPanelOrder() {
    const {
      currentPanel
    } = this.state;

    if (currentPanel === AudienceCreationPanels.AUDIENCE_TYPE_SELECTION) {
      return [currentPanel];
    }

    return [AudienceCreationPanels.AUDIENCE_TYPE_SELECTION, currentPanel];
  }

  render() {
    const {
      audiences,
      fbAccountConnected,
      accessToContactListAudiences,
      screen,
      usageInfoRequestStatus,
      portalUntrustworthy,
      accessToCompanyListAudiences,
      liAccountConnected,
      listBasedAudienceLimit,
      contactListAudienceCreationDisabled,
      reachedListBasedAudienceCreationLimit
    } = this.props;
    const {
      currentPanel
    } = this.state;
    const {
      usageInfo
    } = audiences;
    const loading = !usageInfoRequestStatus.fetchedSuccessfully();
    return /*#__PURE__*/_jsxs(UIPanelNavigator, {
      modal: true,
      currentPanel: currentPanel,
      onPreviousClick: this.onPreviousButtonClick,
      panelOrder: this.getPanelOrder(),
      children: [/*#__PURE__*/_jsx(AudienceCreationTypeSelectPanel, {
        onAudienceTypeSelected: this.onAudienceTypeSelected,
        audienceCounts: usageInfo.get('audienceCounts'),
        loading: loading,
        fbAccountConnected: fbAccountConnected,
        liAccountConnected: liAccountConnected,
        hasAccessToContactListAudiences: accessToContactListAudiences,
        closeAudiencePanel: this.props.onClose,
        panelKey: AudienceCreationPanels.AUDIENCE_TYPE_SELECTION,
        isPortalUntrustworthy: portalUntrustworthy,
        hasAccessToCompanyListAudiences: accessToCompanyListAudiences,
        listBasedAudienceLimit: listBasedAudienceLimit,
        _dontMakeNewLayer: true,
        width: PANEL_WIDTH,
        contactListAudienceCreationDisabled: contactListAudienceCreationDisabled,
        reachedListBasedAudienceCreationLimit: reachedListBasedAudienceCreationLimit
      }), /*#__PURE__*/_jsx(AudienceCreationPanelLoader, {
        type: currentPanel,
        screen: screen,
        panelKey: currentPanel,
        onCloseAudiencePanel: this.props.onClose,
        _dontMakeNewLayer: true,
        width: PANEL_WIDTH
      })]
    });
  }

}

const getUsageInfoRequestStatus = getRequestStatus('audiencesUsageInfo');
export default connect(state => ({
  audiences: state.audiences,
  fetched: isAllAudienceDataFetched(state),
  fbAccountConnected: isFBAccountConnected(state),
  liAccountConnected: isLinkedInAccountConnected(state),
  accessToContactListAudiences: hasAccessToContactListAudiences(state),
  usageInfoRequestStatus: getUsageInfoRequestStatus(state),
  portalUntrustworthy: isPortalUntrustworthy(state),
  accessToCompanyListAudiences: hasLICompanyListAudience(state),
  listBasedAudienceLimit: getListBasedAudienceLimit(state),
  contactListAudienceCreationDisabled: isContactListAudienceCreationDisabled(state),
  reachedListBasedAudienceCreationLimit: metListBasedAudienceCreationLimit(state)
}), {
  fetchAudiences,
  fetchPixels,
  installAndCreatePixels,
  postTimedNotification
})(withScreen(AudiencePanelNavigator));